Librarian.Modules.MountedVuePage = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["onResize"],

    options: {
        classPrefix: "modules-vue-",
        componentId: "vue-component-wrapper",
    },

    vueEl: null,
    oldPadding: null,
    containerEl: null,

    initialize: function (options) {
        this.setOptions(options);
        this.containerEl = $("mounted-vue-page");
    },

    loadVueComponent: function () {
        if (!this.containerEl) {
            console.warn("VueComponentMount: No containerEl available for Vue component.");
            return;
        }

        // Prevent remounting if already mounted
        if ($("vue-app-wrapper")) {
            document.body.fireEvent("show-vue-app");
            return;
        }

        // Create a single wrapper div for the Vue component
        this.vueEl = new Element("div", {
            id: "vue-app-wrapper",
        }).inject(this.containerEl);

        // Fire the event to mount the Vue app
        document.body.fireEvent("show-vue-app");

        this.onResize();
        window.addEvent("resize", this.onResize);
    },

    onResize: function () {
        if (!this.containerEl) return;

        const wrapperEl = $("mainPanel");
        if (wrapperEl) {
            this.containerEl.setStyle("height", wrapperEl.getHeight() + "px");
            this.containerEl.setStyle("width", "100%");
        }
    },

    destroy: function () {
        if (this.oldPadding != null) {
            const mainPadEl = $("mainPanel_pad");
            if (mainPadEl) mainPadEl.style.padding = this.oldPadding;
        }

        if (this.vueEl) {
            this.vueEl.destroy();
            this.vueEl = null;
        }
    },
});

/*** Static functions ***/
Librarian.Modules.MountedVuePage.extend({
    show: function () {
        var itemEl = $("homepage");
        if (itemEl)
            itemEl.hide();

        itemEl = $("pageheader");
        if (itemEl)
            itemEl.hide();

        itemEl = $("crumb");
        if (itemEl)
            itemEl.hide();

        itemEl = $("slideSection");
        if (itemEl)
            itemEl.hide();

        itemEl = $("relatedContent");
        if (itemEl)
            itemEl.hide();

        itemEl = $("search-result-page");
        if (itemEl)
            itemEl.hide();

        itemEl = $("accent-assist-page");
        if (itemEl)
            itemEl.hide();

        if ((typeof tileList != "undefined") && (tileList != null))
            tileList.reset();

        if (Librarian.breadCrumb != null)
            Librarian.breadCrumb.reset();

        Librarian.Utils.unselectAllTrees();

        itemEl = $("mounted-vue-page");
        if (itemEl)
            itemEl.show();
    },

    hide: function () {
        var itemEl = $("mounted-vue-page");
        if (itemEl)
            itemEl.hide();
    }
});

function hideMountedVuePage() {
    Librarian.Modules.MountedVuePage.hide();
}